/* localstorage */
import Vue from 'vue'

const SERVICE = 'ACADEMY'
const MODULE = 'ADMIN'

const storage = {
  setItem: (key, val) => {
    sessionStorage.setItem(`${SERVICE}-${MODULE}.${key}`, val)
  },
  getItem: (key) => {
    return sessionStorage.getItem(`${SERVICE}-${MODULE}.${key}`)
  }
}

Vue.prototype.$sessionStorage = storage
